import React from 'react';
import './browse_send_message.less';
import LoggedinFooter from '../footer/loggedin_footer';
import InputComponent from '../components/input_component/input_component';
import {Link, browserHistory} from 'react-router';
import ShipmentDetailsSection from './shipment_details_section';
import MediaQuery from 'react-responsive';
import {commonFunctions} from './browser_common';
import './browse_paypal_details.less';

import ShowError from '../components/error/show_error';
import validate from '../util/validate';
import {join} from '../util/common';

import browsePackagesAction from './browser_packages_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';


class BrowsePaypaldetails extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      offerData : props.browsePackages.offerData,
      error: ''
    }
  }

  getInputValue = (inputName, value) => {
    let offerData = Object.assign({}, this.state.offerData);
    offerData[inputName] = value;
    this.setState({
      offerData
    });

  }


  componentWillReceiveProps(newProps){
    this.setState({
      offerData: newProps.browsePackages.offerData
    })
  }

  updatePayPalId = () =>{
    let shipmentId = commonFunctions.getShipmentId(this.props.location);

    let paypalIdLocalStore = this.state.offerData.paypalId;

    let paypalIdMainStore;

    let validationErrorMsg = '';

    const validationError = {
        paypal: !validate.email(this.state.offerData.paypalId)
    };
    const validationMap = {
        paypal: 'Paypal EmailId'
    };

    const validationFields = [];

    Object.keys(validationError).forEach((key) => {
        if (validationError[key]) {
            validationFields.push(validationMap[key]);
        }
    });

    if (validationFields.length) {
        validationErrorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }

    if (validationErrorMsg) {
        this.setState({error: validationErrorMsg});
        return;
    }
    // this.props.browsePackagesAction.makeOffer(this.state.offerData);
    // is there is no key in the main store call api and update the main store

    if(! this.props.browsePackages.offerData.hasOwnProperty('paypalId')){
      this.setPaypalId();
    }

    if( this.props.browsePackages.offerData.hasOwnProperty('paypalId') ){
      paypalIdMainStore = this.props.browsePackages.offerData.paypalId
      if(paypalIdMainStore == paypalIdLocalStore){
        // route here
        this.props.browsePackagesAction.makeOffer(this.state.offerData);
        browserHistory.push('/browse-shipments/payment/' +  shipmentId);
        return;
      }else{
        this.setPaypalId();
      }
    }

  }

  getPaypalId = () => {
    this.setState({
      isLoading: true
    })
    this.props.browsePackagesAction.getPaypalAccount().then( (successData) => {
      this.setState({
        isLoading: false
      })
    }, () => {
      this.setState({
        isLoading: false
      })
    })
  }

  setPaypalId = () => {

    let offerData = this.state.offerData;
    let shipmentId = commonFunctions.getShipmentId(this.props.location);

    let params = {
      paypalId: offerData.paypalId
    }

    this.props.browsePackagesAction.addPaypalAccount(params).then( (successData)  => {
      this.setState({
        isLoading: false
      })
      this.props.browsePackagesAction.makeOffer(this.state.offerData);
      browserHistory.push('/browse-shipments/payment/' +  shipmentId);
    }, (error) => {
      this.setState({
        isLoading: false,
        error: error
      })

    })

  }

  componentDidMount(){
    this.getPaypalId();
  }

  render(){

    const {props} = this;
    const self = this;
    commonFunctions.validateOfferData(props.browsePackages ,props.location);
    let shipmentId = commonFunctions.getShipmentId(this.props.location);
    let url = '/browse-shipments/select-delivery-type/'+ shipmentId;
    let paypal = 'https://www.paypal.com';
    return(
      <div>
        <div id="browsePaypalDetails" className="wrapper">
          <Link to={url}>
            <div className="back-section"><span className="icon-icn_back"></span><span className="back-content">Back</span></div>
          </Link>
          <div className="browse-paypal-details-wrap">
            <MediaQuery query='(min-width: 768px)'>
              <div className="shipment-details">
                <ShipmentDetailsSection shipmentId={shipmentId} />
              </div>
            </MediaQuery>
            <div className="paypal-details">
              {this.state.error && <ShowError errorMessage = {this.state.error} />}
              <div id="paypalDetailsHeader">PayPal</div>
              <div id="paypalDetailsDescription">Provide your PayPal information so you can get paid after completing delivery.</div>
              <InputComponent value = {this.state.offerData.paypalId} type={'text'} title={''} placeholder={'PayPal Email'} changeHandler = {this.getInputValue} dollar={false} for='paypalId' />
              <div id="paypalNoemailWrap">
                <span>Don’t have a PayPal account?</span>
                <Link target="_blank" to={paypal}><span id="paypalSignup">Sign Up</span></Link>
              </div>
              <button className="btn orange" onClick={this.updatePayPalId} id="sendMessageButton">Next</button>
            </div>

          </div>
        </div>
        {this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          <LoggedinFooter />
      </div>
    )
  }

}


BrowsePaypaldetails = connect((state) => {
  return {
    authState: state.app.auth,
    browsePackages: state.app.browsePackages,
    shipment: state.app.shipment
  }
}, (dispatch) => {
  return {
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(BrowsePaypaldetails);

export default BrowsePaypaldetails;



// WEBPACK FOOTER //
// app/browse_packages/browse_paypal_details.jsx